import { toggle, up } from "slide-element";
import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';
import isEmpty from 'validator/lib/isEmpty';
import scrollToElement  from 'scroll-to-element';
import axios from 'axios';

import {headerFunc} from "./parts/header.js";
import {faqFunc} from "./parts/faq.js";
import {formFunc} from "./parts/form.js";

headerFunc(toggle, up, scrollToElement);
faqFunc(Accordion);
formFunc(isEmail, isMobilePhone, isEmpty, axios);